import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectTagListProduct, toggleTagList } from '../../../Features/lensSlice';
import { getCachedMediaUrl } from '../../../lib/utils/utils';

function TagProduct({ product }) {
    const dispatch = useDispatch();

    const productID = useSelector((state) => state.lens.tagList.product.id);

    const handleProductClick = () => {
        dispatch(selectTagListProduct({
            name: product.productName,
            id: product.id
        }));
        dispatch(toggleTagList());
    }

    return (
        <div onClick={handleProductClick} className={`w-full ${productID === product.id ? 'bg-primaryColor' : 'bg-[#FFFFFF] hover:bg-[#E5E7EB]'} cursor-pointer p-2`}>
            <div className="w-full flex items-center gap-1">
                <div className="size-[60px] rounded-[10px] overflow-hidden">
                    <img className='size-full object-cover' src={getCachedMediaUrl(product.productImgUrls[0])} alt="" />
                </div>

                <h1 className='w-[calc(100%-60px)] font-medium text-[14px] leading-[16.8px] text-[#121212]'>{product.productName}</h1>
            </div>
        </div>
    );
}

export default TagProduct;
